import { render, staticRenderFns } from "./task.vue?vue&type=template&id=110ad64b&scoped=true"
import script from "./task.vue?vue&type=script&lang=js"
export * from "./task.vue?vue&type=script&lang=js"
import style0 from "./task.vue?vue&type=style&index=0&id=110ad64b&prod&land=scss&lang=css"
import style1 from "./task.vue?vue&type=style&index=1&id=110ad64b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110ad64b",
  null
  
)

export default component.exports